import { jsx as _jsx } from "react/jsx-runtime";
import { ReleaseExpansion } from "./overview/release-expansion.js";
function ReleaseCreate(params) {
    const { rowSelectionServices, rowSelectionContentBlockers, releaseCheck } = params;
    const draftRelease = {
        id: "",
        createdAt: null
    };
    return /*#__PURE__*/ _jsx(ReleaseExpansion, {
        release: draftRelease,
        rowSelectionConfigServices: rowSelectionServices,
        rowSelectionConfigContentBlockers: rowSelectionContentBlockers,
        releaseCheck: releaseCheck
    });
}
export { ReleaseCreate };
